import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { RbUiComponentsModule } from '@inst-iot/bosch-angular-ui-components';

import { VehiclesMgmtRoutingModule } from './vehicles-mgmt-routing.module';
import { VehiclesMgmtComponent } from './vehicles-mgmt/vehicles-mgmt.component';
import { VehiclesComponent } from './vehicles/vehicles.component';
import { SharedPipesModule } from 'src/app/_shared/modules/shared-pipes.module';

@NgModule({
  declarations: [
    VehiclesMgmtComponent,
    VehiclesComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RbUiComponentsModule,
    SharedPipesModule,
    /* VehiclesMgmtRoutingModule */
  ],
  exports: [VehiclesMgmtComponent]
})
export class VehiclesMgmtModule { }
